<mat-form-field class="w-100 p-0 m-0">
    <mat-label>{{_label}}</mat-label>
<input
    matInput
    [name]="id"
    [id]="id"
    [type]="_type"
    [disabled]="_disabled"
    [value]= "_value"
    (input)="valueChanged($event)"
    [required]="required"
    ngModel
    #ctrl="ngModel"
    >
</mat-form-field>